import { render } from "./Scrollbar.vue?vue&type=template&id=82ab8608&scoped=true"
import script from "./Scrollbar.vue?vue&type=script&lang=js"
export * from "./Scrollbar.vue?vue&type=script&lang=js"

import "./Scrollbar.vue?vue&type=style&index=0&id=82ab8608&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82ab8608"]])

export default __exports__